/**
 * Module dependencies.
 */

import { NextPage } from 'next';
import { media } from 'src/styles/media';
import { useLocalizedRoute } from 'src/core/utils/routes';
import BioAwardsSection from 'src/components/sections/bio-awards-section';
import BioContentSection from 'src/components/sections/bio-content-section';
import BioHeaderSection from 'src/components/sections/bio-header-section';
import BioSaramagoSection from 'src/components/sections/bio-saramago-section';
import Footer from 'src/components/footer';
import Metatags from 'src/components/core/metatags';
import TriggerNavbarTheme, {
  useInitialNavbarTheme
} from 'src/components/navbar/trigger-navbar-theme';

import styled from 'styled-components';
import useTranslate from 'src/hooks/use-translate';

/**
 * `Wrapper` styled component.
 */

const Wrapper = styled.div`
  background-color: var(--color-grey-100);
  padding-top: 8rem;

  ${media.min.md`
    padding-top: 10.6rem;
  `}
`;

/**
 * `PeixotoBio` page.
 */

const PeixotoBio: NextPage = () => {
  const { locale, translate } = useTranslate();
  const routeResolver = useLocalizedRoute();

  useInitialNavbarTheme('dark');

  return (
    <>
      <Metatags
        title={`${translate(
          'biography-peixoto:headerSection.title'
        )} - ${translate('biography-peixoto:headerSection.subtitle')}`}
      />

      <TriggerNavbarTheme colorTheme={'dark'} />

      <Wrapper>
        <BioHeaderSection
          imageUrl={`/images/peixoto-face-${locale}.jpg`}
          imageUrlMobile={`/images/peixoto-face-mobile-${locale}.jpg`}
          subtitle={translate('biography-peixoto:headerSection.subtitle')}
          title={translate('biography-peixoto:headerSection.title')}
        />

        <BioContentSection
          description={translate(
            'biography-peixoto:contentSection.description'
          )}
        />

        <BioAwardsSection />

        <BioSaramagoSection
          colorTheme={'dark'}
          imageTitle={translate(`biography-peixoto:nextBioSection.imageTitle`)}
          imageUrl={'/images/saramago.png'}
          label={translate(`biography-peixoto:nextBioSection.label`)}
          linkLabel={translate(`biography-peixoto:nextBioSection.linkLabel`)}
          linkUrl={routeResolver('saramagoBio')}
          subtitle={translate(`biography-peixoto:nextBioSection.subtitle`)}
          title={translate(`biography-peixoto:nextBioSection.title`)}
        />
      </Wrapper>

      <Footer />
    </>
  );
};

/**
 * Export `PeixotoBio` page.
 */

export default PeixotoBio;
